<template>
	<div id="select-plan">
		<h6 class="sub-title">{{$t('planesYPrecios.titulo')}}<span>{{$t('planesYPrecios.subTitulo')}}</span></h6>
		<div>
			<div class="filter-center">
				<b-dropdown id="selectPlan-dropdown"
					:text="selected == null ? 
							$t('planesYPrecios.seleccionar_ver_precios')  
							:  selected== TIPO_PLANES_IDS.PLAN_INDIVIDUAL ?  $t('planesYPrecios.plan_individual') :  selected == TIPO_PLANES_IDS.PLAN_DOS_PERSONAS ?  $t('planesYPrecios.plan_dos_personas') : selected == TIPO_PLANES_IDS.PLAN_TRES_MAS_PERSONAS ?  $t('planesYPrecios.plan_tres_mas_personas') : ''
						   " 
					variant="link"  toggle-class="text-decoration-none"  no-caret class="dropdown-checkbox" 
					:class="[classSelect]" ref="dropdown"
				>
					<b-form-radio-group v-model="selected">
						<b-dropdown-text>
							<h6>{{$t('planesYPrecios.paso-1.dropdown.sub-titulo')}}</h6>
							<b-form-radio :value="item.id" v-for="item in plansTypes.plansTypesIndividual"
							 :key="item.id" :id="'planType'+item.id" @change="selectedPlanType(item.id, false)" :disabled="$store.state.is_group">
								{{ item.id == TIPO_PLANES_IDS.PLAN_INDIVIDUAL ?  $t('planesYPrecios.plan_individual') : ''}}
							</b-form-radio>
						</b-dropdown-text>
						<b-dropdown-text>
							<h6>{{$t('planesYPrecios.paso-1.dropdown.sub-titulo-2')}}</h6>
							<b-form-radio :value="item.id" v-for="item in plansTypes.plansTypesGroup"
							 :key="item.id" :id="'planType'+item.id" @change="selectedPlanType(item.id, true)">
								{{ item.id == TIPO_PLANES_IDS.PLAN_DOS_PERSONAS ?  $t('planesYPrecios.plan_dos_personas') : item.id == TIPO_PLANES_IDS.PLAN_TRES_MAS_PERSONAS ?  $t('planesYPrecios.plan_tres_mas_personas') : ''}}
							</b-form-radio>
							<i>* {{$t('planesYPrecios.paso-1.dropdown.text.1', {NRO: CONSTANTES.GROUP_MAX_STUDENTS})}}</i>
						</b-dropdown-text>
					</b-form-radio-group>
				</b-dropdown>
				<icon id="info-1" class="ml-2 icon-info" name="info" />
				<b-tooltip target="info-1" custom-class="tooltipHeader" placement="right">
					{{$t('planesYPrecios.paso-1.dropdown.text.2')}}
				</b-tooltip>
			</div>
			<p class="error-label center" :style="{visibility: alertError ? 'visible' : 'hidden'}" >{{$t('planesYPrecios.paso-1.dropdown.text.3')}}</p>
		</div>
    	<div class="plans_container" :class="{cardsCenter:disabledButtons}">
			<carousel 
				v-if="plans.plansRegular" 
				:dots="true" 
				:nav="false" 
				:autoWidth="true"
				:margin="17"
				:center="true"
				:responsive="{
					381:{center:false},
					1100:{items:5,center:false,autoWidth:false},
					1300:{mouseDrag:false,touchDrag:false,dots:false,center:false}
				}"
			>
				<div class="card card_plan " v-for="item in plans.plansTest" :key="item.id" :id="'planTest'+item.id">
					<div class="card-body">
						<div class="test-class">
							<img src="@/assets/img/hand.png" />
							{{$t('reusables.test-class')}}
						</div>
						<h1 class="price" v-if="flagLista == false?false:true"><i>$</i>{{item.price}}</h1> 
						<p>{{$t('reusables.test-class-description')}}</p> 
						<b-button v-if="!disabledButtons" :disabled="disabledButtons" variant="primary" @click="isDesktop ? selectedPlan(item) + send(flagGroupPlan) : showModalDevice()" style="margin-top:auto;">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
						<b-button v-else  class="disabled" @click="showMsgAlert();" style="margin-top:auto;pointer-events: auto">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
					</div>
				</div>
				<div class="card card_plan" v-for="(item,index) in plans.plansRegular" :key="item.id" :id="'planRegular'+item.id">
					<div :class="'card-header gd-n-'+(index+1)" :id="'SelectPlan'+index" >{{item.duration}} {{$t('reusables.hours')}}</div>
					<div class="card-body"  >
						<h1 class="price" v-if="flagLista==false?false:true"><i>$</i>{{item.price}}</h1>
						<p v-if="flagLista==false?false:true">{{$t('reusables.costo-por-hora', {cost: item.hourPrice})}}</p>
						<p>{{$t('reusables.vigencia_meses', {NRO: item.meses})}}
							<icon v-if="item.tooltip" :id="'tooltip'+index" class="ml-1 icon-info" name="info" />
							<b-tooltip :target="'tooltip'+index" custom-class="tooltipPlan"  placement="bottom"> {{$t('reusables.vigencia_meses_tooltip', {NRO: item.meses})}}</b-tooltip>
						</p>
						<b-button v-if="!disabledButtons"  :disabled="disabledButtons" variant="primary" @click=" isDesktop ? selectedPlan(item) + send(flagGroupPlan) : showModalDevice()">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
						<b-button v-else  class="disabled" @click="showMsgAlert();" style="margin-top:auto;pointer-events: auto">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
					</div>
				</div>
				<div class="card card_plan" v-for="item in plans.plansEnterprise" :key="item.id" :id="'planEnterprise'+item.id">
					<div class="card-body">
						<h1 class="price"  style="font-size: 22px;">{{$t('reusables.enterprise_plan')}}</h1>
						<!-- <b-button :disabled="disabledButtons" variant="primary" @click="nextStep();selectedPlan(item);send();">Quiero este</b-button> -->
						<b-button v-if="!disabledButtons"  :disabled="disabledButtons" @click="isDesktop ? validateBusinessGroup() : showModalDevice()">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
						<b-button v-else  class="disabled" @click="showMsgAlert();" style="pointer-events: auto">{{$t('planesYPrecios.paso-1.planes.button')}}</b-button>
					</div>
				</div>
			</carousel>
    	</div>
		<h3 class="text-md">{{$t('planesYPrecios.paso-1.footer')}}</h3>

		<b-modal id="modal-logfirst" :hide-footer="true" :hide-header="true" :centered="true" >
			<div class="img_modal">
				<img src="@/assets/img/modal_notes.png" alt="" />
			</div>
			<div class="content">
				<img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modal-logfirst')" />
				<h3>
					{{$t('planesYPrecios.paso-1.modal-logfirst.sub-titulo')}}
				</h3>
				<b-button variant="outline-primary" class="style-button-upload" to="/student/login">
					<span >{{$t('planesYPrecios.paso-1.modal-logfirst.text')}}</span>
				</b-button>
			</div>
		</b-modal>

		<b-modal id="modal-plan-active" 
		:hide-footer="false" 
		:hide-header="false"
		:hide-body="true" 
		:centered="true">
			<template #modal-header="{ close }">
				<img class="close" src="@/assets/img/close_red.png" @click="close()" />
				<!-- <header class="text-center">
					<h6 class="sub-title"><span>{{$t('planesYPrecios.paso-1.modal-plan-active.sub-titulo')}}</span></h6>
				</header> -->
				<p class="text-center">{{$t('planesYPrecios.paso-1.modal-plan-active.sub-titulo')}}</p>
            </template>
			<template #modal-footer>
				<b-button variant="primary" @click="$bvModal.hide('modal-plan-active')" >
					{{$t('planesYPrecios.paso-1.modal-plan-active.text')}}
				</b-button>
            </template>
		</b-modal>

		<b-modal id="modal-plan-active-test"
		:hide-footer="false" 
		:hide-header="false"
		:hide-body="true" 
		:centered="true">
			<template #modal-header="{ close }">
				<img class="close" src="@/assets/img/close_red.png" @click="close()" />
				<p class="text-center">{{$t('planesYPrecios.paso-1.modal-plan-active-test.sub-titulo')}}</p>
            </template>
			<template #modal-footer>
				<b-button variant="primary" @click="$bvModal.hide('modal-plan-active-test')">
					{{$t('planesYPrecios.paso-1.modal-plan-active-test.text')}}
				</b-button>
            </template>
		</b-modal>

		<b-modal id="modal-group-varios" :hide-footer="true" :hide-header="true" :centered="true">
			<div class="content">
				<img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modal-group-varios')" />
				<img class="alert-img" src="@/assets/img/modal-alert-code.png" @click="$bvModal.hide('modal-group-varios')" />
				<p>
					{{messageGroupVarios}} <span> {{messageGroupVarios1}} </span> {{messageGroupVarios2}}
				</p>
				<div class="links">
					<b-link :href="'mailto:'+ CONSTANTES.EMAIL">
						<icon name="msg" />
						<span>{{CONSTANTES.EMAIL}}</span>
					</b-link>
					<b-link :href="'https://wa.me/' + CONSTANTES.WHATSAPP_URL" target="_blank">
						<icon name="whatsapp" />
						<span>{{CONSTANTES.WHATSAPP}}</span>
					</b-link>
				</div>
				<div class="text-center">
					<b-button class="btn btn-primary" @click="$bvModal.hide('modal-group-varios')" >
						{{$t('planesYPrecios.paso-1.modal-group-varios.text')}}
					</b-button>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
	import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
    import { TIPO_PLANES, TIPO_CATALOGO, CONSTANTES, TIPO_PLANES_IDS, DEVICE } from '@/assets/js/appConstants';
	import { hideSidebar } from '@/assets/js/util.js';
	import carousel from 'vue-owl-carousel';
	
	export default {
		components: { 
			carousel
		},
		data(){
			return{
				statusSelectPlan:false,
				API_URL: process.env.VUE_APP_API_URL,
				planType: {},
				plansTypes: {},
				plans: {},
				alertError:false,
				disabledButtons: true,
				selected: null,
				listPlansEnterprise:[],
				boxTwo: '', //modal del ultimo plan
				flagLista:false,
				planSelected:{
                    typeId:0,
                    id:0,
		            planPriceId : 0,
					planPriceTypeId:0,
                    type :{
                        code : '',
                        name : '',
                        value : ''
                    },
                    name : '',
                    description : '',
                    tooltip : '',
                    price : 0.00,
                    duration : 0
                },
				flagGroupPlan: false,
				messageGroupVarios:"",
				messageGroupVarios1:"",
				messageGroupVarios2:"",
				flagLoading: false,
				CONSTANTES: CONSTANTES,
				TIPO_PLANES_IDS: TIPO_PLANES_IDS,
				isDesktop: window.innerWidth > DEVICE.DESKTOP,
			}
		},
		watch: {
			planType(val) {
				if(val != {}){
					this.alertError=false;
					//this.disabledButtons = false;
				}else{
				   //this.disabledButtons = true;
				   this.alertError=true; 
				}
			}
		},
		props: {
			nextStep: {
				type: Function,
				default() {
					return {}
				}
			},
			groupPersonData :{
				type: Object
			}
		},
		computed: {
			classSelect(){
				return this.selected == null ? 'red' : '' 
			},
			User: {
				get() {
					return this.$store.state.user;
				},
				set(value) {
					this.$store.commit('mutateUser', value);
				}
			},
		 
		},
		created() {
			hideSidebar(this.User, 0, this.$store.state.datosSidebar) 
			this.getPlansTypes();
		},
		mounted(){
			if(this.$store.state.user != null){
				this.getGroupGoal();

			}
			
	 
		},
		methods: {
			
			successCallback: function(result) {
				console.log("Audio file ready at URL: " + result);
			},

			failureCallback: function(error) {
				console.error("Error generating audio file: " + error);
			},
			showMsgAlert(){
				this.alertError=true;
			},
			getGroupGoal: function(){
				
				baseInstanceAxios
				.get(this.API_URL + `/resources/Groups/GetGroupGoal?idStudent=${this.$store.state.user.personStudentId}`)
				.then(response => {
					if(response.data != null && response.data.entity != null){
						this.groupPersonData.personStudent.goalSelected = response.data.entity.goal;
						this.groupPersonData.personStudent.examSelected = response.data.entity.subject;
						
					}
				});
				 
			 
			},
			getPlansTypes: function() {
				baseInstanceAxios
					.get(this.API_URL + `/Administration/Catalogs/ListTable?Code=${TIPO_CATALOGO.TIPO_PLANES}`)
					.then(response => {
						var data = response.data != null ? response.data.list : null;
						
						if(data != null){
							var plansTypesIndividual = data.filter(function(element) {
								return element.value == TIPO_PLANES.TIPO_REGULAR;
							});

							var plansTypesGroup = data.filter(function(element) {
								return element.value == TIPO_PLANES.TIPO_SUB_REGULAR;
							});

							this.plansTypes = {};
							this.plansTypes.plansTypesIndividual = plansTypesIndividual.length != 0 ? plansTypesIndividual: [];
							this.plansTypes.plansTypesGroup = plansTypesGroup.length != 0 ? plansTypesGroup: [];
 
							this.getPlans(this.planType.id);
						}
					});
			},
			getPlans: function(planTypeId) {
				this.disabledButtons = true;
				let typeId = planTypeId == undefined ? null:planTypeId;
				baseInstanceAxios
					.get(this.API_URL + `/Sales/Plans/List?Filter=&TypeId=${typeId}&PlanPreviousTypeId=&FlagType=true&Page=1&Size=100`)
					.then(response => {
						var data = response.data != null ? response.data.list : null;
						if(data != null){
						
						  let plansRegular =[];
                          let plansTest = [];
                          let plansEnterprise = []; 
						  if (typeId == null) {
							this.flagLista =false;
	                        plansTest = data.filter(function(element) {
								return element.type.value == TIPO_PLANES.TIPO_PRUEBA; 
							});
							plansEnterprise = data.filter(function(element) {
								return element.type.value == TIPO_PLANES.TIPO_EMPRESAS;
							});
							plansRegular = data.filter(function(element) {
								return (element.type.value != TIPO_PLANES.TIPO_PRUEBA && element.type.value !=TIPO_PLANES.TIPO_EMPRESAS);
							});
				            this.listPlansEnterprise = plansEnterprise ;
							
							this.plans = {};
							this.plans.plansTest = plansTest.length != 0 ? plansTest: [];
							this.plans.plansRegular = plansRegular.length != 0 ? plansRegular: [];
							this.plans.plansEnterprise = plansEnterprise.length != 0 ? plansEnterprise: [];
						  }
						  else
							{
							this.flagLista =true;
                            plansTest = data.filter(function(element) {
								return element.type.value == TIPO_PLANES.TIPO_PRUEBA;//todo
							});
							plansRegular = data.filter(function(element) {
								return (element.type.value != TIPO_PLANES.TIPO_PRUEBA && element.type.value !=TIPO_PLANES.TIPO_EMPRESAS);
							});
						    this.plans = {};	
							this.plans.plansTest = plansTest.length != 0 ? plansTest: [];
							this.plans.plansRegular = plansRegular.length != 0 ? plansRegular: [];
							this.plans.plansEnterprise = this.listPlansEnterprise.length != 0 ? this.listPlansEnterprise: [];
							//Activar los botones de "Quiero este"//
							let countNoPlansPrice = false;
                              if (this.plans.plansTest.length != 0 
							       &&  this.plans.plansRegular.length != 0 
								     && this.plans.plansEnterprise.length != 0) 
							  {
								  if (this.plans.plansTest[0].planPriceId > 0 && this.plans.plansRegular[0].planPriceId > 0) {
									    countNoPlansPrice = true;
								  }
								
							  }
							  if (countNoPlansPrice) {
								  this.disabledButtons = false;
							  }
							}				
                        
						
						}
					});
			},
			selectedPlan: function(plan) {
				this.planSelected={
                    typeId:plan.typeId,
                    id:plan.id,
		            planPriceId : plan.planPriceId,
					planPriceTypeId:plan.planPriceTypeId,
                    type :{
                         code : plan.type.code,
                         name : plan.type.name,
                         value : plan.type.value
                    },
                    name : plan.name,
                    description : plan.description,
                    tooltip : plan.tooltip,
                    price : plan.price,
                    duration : plan.duration
				}
				
			},
			selectedPlanType: function(planTypeId, flagGroupPlan) {
				this.flagGroupPlan = flagGroupPlan;
				this.$refs.dropdown.hide()
				this.plansTypes.plansTypesIndividual.forEach(element => {
					if (element.id == planTypeId) {
						this.planType = {
							name: element.name,
							id: element.id
						}
					}
				});

				this.plansTypes.plansTypesGroup.forEach(element => {
					if (element.id == planTypeId) {
						this.planType = {
							name: element.name,
							id: element.id
						}
					}
				});
				//debugger;
				this.getPlans(this.planType.id);
			},
			send(flagOnlyGroup = false) {
				// this.disabledButtons = true;
				this.disabledButtons = false;
				if(this.User != null){
					//debugger;
					this.data = {
						plan: this.planSelected,
						planPreviousTypeId:this.planSelected.typeId,
						planTypeId: this.planType.id
					};

					let dataPost = {
						personStudentId: this.groupPersonData.personStudent.id, 
						planPriceId:  this.data.plan.planPriceId,
						typePlanPriceId: this.data.plan.planPriceTypeId,
						userCreated: this.User.email
					}
					baseInstanceAxios
						.post(this.API_URL + `/Resources/Groups/SavePlanPricePreview`, dataPost)
						.then(response => {
							//console.log("response.data: ",response.data)
							if (response.data != null) {
								if(response.data.value == -1){
									this.$bvModal.show("modal-plan-active-test");
									this.disabledButtons = false;
								}
								else{
									if(response.data.entity != null && response.data.return){
										this.data.groupId = response.data.entity.groupId;
										this.data.groupPersonId =  response.data.entity.id;
										this.data.flagGroup =     response.data.entity.group.flagGroup;
										this.data.flagGroupCode = response.data.entity.group.flagGroupCode;

										this.User.groupId = response.data.entity.groupId;
										this.User.groupPersonId =  response.data.entity.id;
										this.$store.commit('mutateUser', this.User);
										this.$store.commit('mutateGroupId', response.data.entity.groupId);
										this.$store.commit('mutateGroupPersonId', response.data.entity.id);

										this.$emit('listenChild', this.data);
										this.messageGroupVarios = "";

										if(!flagOnlyGroup){
											if(this.data.flagGroup){

												if(response.data.entity.group.flagGroupRepresentative){
													this.tabIndex = 4;
													this.$router.push('/compra/'+this.tabIndex);
												}else{
													
													this.messageGroupVarios = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-representative');
													this.showModalGroupRepresentative();
												}
											}else{

												if(response.data.entity.group.flagGroupCode){
													
													this.tabIndex = 4;
													this.$router.push('/compra/'+this.tabIndex);
												}else{
													this.nextStep();
												}
												
											}
										}else{
										 
											if(!this.data.flagGroup){
												this.messageGroupVarios = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business');
												this.messageGroupVarios1 = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business-2');
												this.messageGroupVarios2 = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business-3');
												this.showModalGroupRepresentative();
												this.disabledButtons = false;
											}else{
												if(response.data.entity.group.flagGroupRepresentative){
													if(response.data.entity.group.flagGroupCode){
														this.tabIndex = 4;
														this.$router.push('/compra/'+this.tabIndex);
													}else{
														this.messageGroupVarios = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business');
														this.messageGroupVarios1 = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business-2');
														this.messageGroupVarios2 = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-business-3');
														this.showModalGroupRepresentative();
													}
												}else{
													this.messageGroupVarios = this.$t('planesYPrecios.paso-1.modal-group-varios.flag-group-representative');
													this.showModalGroupRepresentative();
												}
											}
										}

										
									}else{
										this.showModalPlanActive();
									}
								}
							}
						});
				}else{
					this.$bvModal.show("modal-logfirst")
				}
			},
			validateBusinessGroup() {
				 
				this.send(true);
				/*
				this.boxTwo = ''
				this.$bvModal.msgBoxOk('Plan para empresas', {
					title: 'Modal de plan para empresas',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					headerClass: 'p-2 border-bottom-0',
					footerClass: 'p-2 border-top-0',
					centered: true
				})
				.then(value => {
					this.boxTwo = value
				})
				// .catch(err => {
				// 	// An error occurred
				// })
				*/
			},
			showModalPlanActive: function(){
				this.$bvModal.show("modal-plan-active")
			},
			showModalGroupRepresentative: function(){
				this.$bvModal.show("modal-group-varios")
			},
			showModalDevice() {
				this.$bvModal.show("modal-device") 
			}
		},
	}
</script>